const Bank = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        opacity="0.4"
        d="M1.03293 8L18.9671 8C19.9872 8 20.3878 6.64858 19.539 6.07059L11.1438 0.353751C10.4512 -0.117917 9.54882 -0.117917 8.85618 0.35375L0.461015 6.07059C-0.387764 6.64858 0.0128218 8 1.03293 8Z"
        fill="#6B50FF"
      />
      <rect x="4" y="8" width="4" height="8" fill="#6B50FF" />
      <rect x="12" y="8" width="4" height="8" fill="#6B50FF" />
      <path
        opacity="0.4"
        d="M17.382 16C17.7608 16 18.107 16.214 18.2764 16.5528L19.2764 18.5528C19.6089 19.2177 19.1254 20 18.382 20L1.61808 20C0.874697 20 0.391199 19.2177 0.72365 18.5528L1.72365 16.5528C1.89304 16.214 2.23931 16 2.61808 16L17.382 16Z"
        fill="#6B50FF"
      />
    </svg>
  );
};

export default Bank;
